import React, { memo } from 'react';
import MatTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Spinner from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
import DeviceHistoryTableHead from './DeviceActivationLogsTableHead';
import useStyles from './styles';
import { defaultDateFormat, formatDate, timeFormat } from '../../../utils/date';
import { DeviceActivationLog } from '../../../types/inputTypes/Device';

const ActionMapping: any = {
  remove: 'Removed, not sold',
  activate: 'Activated',
  mask_as_sold: 'Removed, marked as sold',
};

type Props = {
  isLoading: boolean;
  logs?: DeviceActivationLog[];
};

const DeviceActivationLogsTable = ({ isLoading, logs }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.tableWrapper}>
      {isLoading && (
        <Box className={classes.spinnerWrapper}>
          <Spinner />
        </Box>
      )}
      <MatTable className={classes.tableRoot}>
        <DeviceHistoryTableHead />
        <TableBody>
          {logs?.map(log => {
            const createdOn = formatDate(log.created_on, `${defaultDateFormat} ${timeFormat}`);

            return (
              <TableRow
                hover
                role="checkbox"
                classes={{ root: classes.rowRoot }}
                key={log.id}
                tabIndex={-1}
              >
                <TableCell align="center">{log.id}</TableCell>
                <TableCell align="center">{log.hub_type}</TableCell>
                <TableCell align="center">{log.lock_type}</TableCell>
                <TableCell align="center">{log.serial_number}</TableCell>
                <TableCell align="center">{log.property_id}</TableCell>
                <TableCell align="center">{ActionMapping[log.action] || log.action}</TableCell>
                <TableCell align="center">{createdOn}</TableCell>
                <TableCell align="center">{log.created_by}</TableCell>
                <TableCell align="center">{log.created_by_email}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </MatTable>
    </Box>
  );
};

export default memo(DeviceActivationLogsTable);
